<ng-container *ngIf="isFarmingIncluded">
  <div class="scrollable-table-container">
    <table mat-table [dataSource]="dataSource" class="table table-primary-color">

      <ng-container matColumnDef="tipoAllevamento">
        <th mat-header-cell *matHeaderCellDef> Tipo allevamento </th>
        <td mat-cell *matCellDef="let element"> {{element.tipoAllevamento}} </td>
      </ng-container>

      <ng-container matColumnDef="numeroCapi">
        <th mat-header-cell *matHeaderCellDef> Numero capi </th>
        <td mat-cell *matCellDef="let element"> {{element.numeroCapi | number: undefined : 'it'}} </td>
      </ng-container>

      <ng-container matColumnDef="conduzioneStalle">
        <th mat-header-cell *matHeaderCellDef> Conduzione stalle </th>
        <td mat-cell *matCellDef="let element"> {{element.conduzioneStalle}} </td>
      </ng-container>

      <ng-container matColumnDef="provincia">
        <th mat-header-cell *matHeaderCellDef> Provincia </th>
        <td mat-cell *matCellDef="let element"> {{element.provincia}} </td>
      </ng-container>

      <ng-container matColumnDef="canoneAffitto">
        <th mat-header-cell *matHeaderCellDef> Canone affitto </th>
        <td mat-cell *matCellDef="let element"> {{element.canoneAffitto | currency : "EUR" : "symbol" : "1.2-2" : "it"}}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Azioni </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="!praticaProgressService.isFrozen">
            <button mat-icon-button class="icon-button" aria-label="Modifica dati allevamento"
              matTooltip="Modifica dati allevamento" (click)="openFarmingInfoDialog(element)">
              <mat-icon svgIcon="edit"></mat-icon>
            </button>
            <button mat-icon-button class="icon-button" aria-label="Elimina dati allevamento"
              matTooltip="Elimina dati allevamento" (click)="deleteFarmingInfo(element)">
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" style="text-align: center; padding: 20px 0;" colspan="7">Nessun dato presente al
          momento.
        </td>
      </tr>
    </table>
  </div>
  <div class="margin-top-rounded-buttons">
    <button mat-flat-button color="accent" class="squared-button" aria-label="Aggiungi dati allevamento"
      matTooltip="Aggiungi dati allevamento" [disabled]="praticaProgressService.isFrozen"
      (click)="openFarmingInfoDialog()">
      +
    </button>
  </div>
</ng-container>